import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import AhmedIshmaelPic from "./assets/images/Ahmed Ishmael Pic.jpg";
import { GrMail } from "react-icons/gr";
import { GrSkype } from "react-icons/gr";
import { GrLinkedin } from "react-icons/gr";
import { GrGithub } from "react-icons/gr";

const About = () => {
  return (
    <Container>
      <section id="about" className="pt-5 px-5">
        <h3 className="mb-5">ABOUT</h3>
        <Container>
          <Row>
            <Col lg={4} className="d-flex flex-column align-items-center">
              <img
                id="profile-pic"
                className="mb-3"
                src={AhmedIshmaelPic}
                alt="Ahmed Ishmael"
                width="150px"
                style={{
                  outline: "3px solid white",
                  borderRadius: "3px",
                }}
              />
              <h2>Ahmed Ishmael</h2>
              <p style={{ color: "gray" }}>@ahmedmishmael</p>
              <h5>Frontend Web Developer</h5>
              <div className="d-flex mb-5">
                {" "}
                <a
                  href="mailto:ahmedm.ishmael@outlook.com"
                  target="_blank"
                  rel="noreferrer"
                  className="mx-1"
                >
                  <GrMail style={{ color: "black", fontSize: "x-large" }} />
                </a>{" "}
                <a
                  href="skype:.cid.1644a0858e9613b1"
                  target="_blank"
                  rel="noreferrer"
                  className="mx-1"
                >
                  <GrSkype style={{ color: "black", fontSize: "x-large" }} />
                </a>{" "}
                <a
                  href="https://www.linkedin.com/in/ahmedmishmael"
                  target="_blank"
                  rel="noreferrer"
                  className="mx-1"
                >
                  <GrLinkedin style={{ color: "black", fontSize: "x-large" }} />
                </a>{" "}
                <a
                  href="https://github.com/ahmedmishmael"
                  target="_blank"
                  rel="noreferrer"
                  className="mx-1"
                >
                  <GrGithub style={{ color: "black", fontSize: "x-large" }} />
                </a>
              </div>
            </Col>
            <Col lg={8}>
              <h3>Personal Info</h3>
              <p>
                Name: Ahmed M. Ishmael
                <br />
                Date of birth: April 15, 1992
                <br />
                Nationality: Egyptian
                <br />
                Lives in: Cairo, Egypt
              </p>
              <h3>Education</h3>
              <p>Bachelor's degree from Mansoura University</p>
              <h3>Skills</h3>
              <p>
                C++ - HTML5 - CSS3 - Bootstrap - Tailwind CSS - Sass -
                JavaScript - TypeScript - React JS
              </p>
              <h3>Work</h3>
              <p>Frontend Web Developer</p>
              <h3>Contact Details</h3>
              <p>
                Telephone: +20 22 198-9375
                <br />
                Cell: +20 155 111-4793
                <br />
                Website: https://ahmedmishmael.github.io
                <br />
                Email: ahmedm.ishmael@outlook.com
              </p>
              <h3>About Website</h3>
              <p>Coded with &hearts; by Ahmed Ishmael using React JS</p>
            </Col>
          </Row>
        </Container>
      </section>
    </Container>
  );
};

export default About;
